const LVTXIII_PDP_SPRITE_URL = 'https://cdn.shopify.com/s/files/1/0441/5019/4336/files/lvtxiii-pattern-sprite-101.webp?v=1788259924';
const LVTXIII_PDP_COLUMNS = 11;
const LVTXIII_PDP_ROWS = 10;
const LVTXIII_PDP_CELL = 48;
const LVTXIII_PATTERN_POSITIONS = {
  BDZY:[0,0], BJYZ:[1,0], CSBZ:[2,0], CSHT:[3,0], CSSH:[4,0], CSYD:[5,0], DXYQ:[6,0], FGBH:[7,0], FGHT:[8,0], FGSY:[9,0], FLHT:[10,0],
  FYWH:[0,1], GDLW:[1,1], HBFH:[2,1], HBMS:[3,1], HBTW:[4,1], HDBH:[5,1], HDJH:[6,1], HDLH:[7,1], HDXRK:[8,1], HJYZ:[9,1], HLHT:[10,1],
  HLKT:[0,2], HLVHT:[1,2], HSJH:[2,2], HSMP:[3,2], HXT:[4,2], HYZ:[5,2], HZHT:[6,2], JBLY:[7,2], JLZL:[8,2], JRHH:[9,2], LANFD:[10,2],
  LANSY:[0,3], LBFH:[1,3], LBJY:[2,3], LCHH:[3,3], LDLH:[4,3], LDXH:[5,3], LGBY:[6,3], LHMD:[7,3], LJH:[8,3], LJLH:[9,3], LLHX:[10,3],
  LLLX:[0,4], LLXT:[1,4], LLYZ:[2,4], LSCL:[3,4], LVSY:[4,4], LVZL:[5,4], LVZYZ:[6,4], LXJY:[7,4], LYD:[8,4], LYLH:[9,4], LYMG:[10,4],
  LYWH:[0,5], LZRG:[1,5], MCYZ:[2,5], MHHT:[3,5], MXT:[4,5], MZXT:[5,5], NZFG:[6,5], NZKT:[7,5], NZXT:[8,5], OLFBE:[9,5], OLFDG:[10,5],
  OLFRE:[0,6], QHBT:[1,6], QHHT:[2,6], QHYQ:[3,6], QLHT:[4,6], QLVHT:[5,6], QLYH:[6,6], RDYH:[7,6], SMBH:[8,6], SMYZ:[9,6], SSGZ:[10,6],
  TWHL:[0,7], TWYWH:[1,7], TXHY:[2,7], WZQH:[3,7], XBDHTH:[4,7], XHFH:[5,7], XHH:[6,7], XHTH:[7,7], XLFH:[8,7], XLH:[9,7], XLT:[10,7],
  YDFG:[0,8], YGTW:[1,8], ZQBH:[2,8], ZQBT:[3,8], ZQBY:[4,8], ZQHT:[5,8], ZQJH:[6,8], ZQMP:[7,8], ZQTW:[8,8], ZQWJ:[9,8], ZQYG:[10,8],
  ZSQNH:[0,9], ZYH:[1,9]
};

const productCache = new Map();
const pendingPickers = new Set();
let decorateFrame = null;

function ensurePdpPatternStyles() {
  if (document.getElementById('lvtxiii-pdp-pattern-swatch-styles')) return;
  const style = document.createElement('style');
  style.id = 'lvtxiii-pdp-pattern-swatch-styles';
  style.textContent = `
    variant-picker .variant-option.lvtxiii-pattern-option { gap: 10px; }
    variant-picker .lvtxiii-pattern-option legend { width: 100%; margin-block-end: 10px; }
    .lvtxiii-pattern-selected-value { margin-inline-start: 8px; color: var(--color-foreground-subdued); font-weight: 400; }
    variant-picker .variant-option__button-label.lvtxiii-pattern-swatch {
      position: relative; flex: 0 0 56px; width: 56px; min-width: 56px; height: 56px; min-height: 56px;
      padding: 3px; border: 1px solid rgb(var(--color-foreground-rgb) / 18%); border-radius: 9px;
      background: transparent; overflow: visible;
    }
    variant-picker .variant-option__button-label.lvtxiii-pattern-swatch:hover { border-color: rgb(var(--color-foreground-rgb) / 55%); }
    variant-picker .variant-option__button-label.lvtxiii-pattern-swatch:has(input:checked) {
      border-color: var(--color-foreground); outline: 2px solid var(--color-foreground); outline-offset: 2px;
    }
    .lvtxiii-pattern-swatch__image {
      display: block; width: 48px; height: 48px; border-radius: 6px; background-repeat: no-repeat;
      background-image: url("${LVTXIII_PDP_SPRITE_URL}");
      background-size: ${LVTXIII_PDP_COLUMNS * LVTXIII_PDP_CELL}px ${LVTXIII_PDP_ROWS * LVTXIII_PDP_CELL}px;
      pointer-events: none;
    }
    variant-picker .lvtxiii-pattern-swatch .variant-option__button-label__pill,
    variant-picker .lvtxiii-pattern-swatch .variant-option__button-label__text { position: absolute; width: 1px; height: 1px; padding: 0; margin: -1px; overflow: hidden; clip: rect(0,0,0,0); white-space: nowrap; border: 0; }
    variant-picker .lvtxiii-pattern-swatch .variant-option__strikethrough { z-index: 3; inset: 3px; width: 48px; height: 48px; opacity: .75; }
    @media (max-width: 749px) {
      variant-picker .variant-option.lvtxiii-pattern-option { gap: 8px; }
      variant-picker .variant-option__button-label.lvtxiii-pattern-swatch { flex-basis: 54px; width: 54px; min-width: 54px; height: 54px; min-height: 54px; padding: 2px; }
    }
  `;
  document.head.appendChild(style);
}

function codeFromSku(sku) {
  const code = String(sku || '').split('-').pop()?.toUpperCase();
  return code && LVTXIII_PATTERN_POSITIONS[code] ? code : null;
}

function embeddedProduct(picker) {
  const productId = picker.dataset.productId;
  if (!productId) return null;
  const script = document.querySelector(`script[data-lvtxiii-product-variants="${CSS.escape(productId)}"]`);
  if (!(script instanceof HTMLScriptElement)) return null;
  try {
    const variants = JSON.parse(script.textContent || '[]');
    return Array.isArray(variants) ? { variants } : null;
  } catch (_) {
    return null;
  }
}

async function loadProduct(picker) {
  const embedded = embeddedProduct(picker);
  if (embedded?.variants?.length) return embedded;
  const handle = picker.dataset.productHandle;
  if (!handle) return null;
  if (productCache.has(handle)) return productCache.get(handle);
  const root = window.Shopify?.routes?.root || '/';
  const promise = fetch(`${root}products/${encodeURIComponent(handle)}.js`, { credentials: 'same-origin' })
    .then((response) => response.ok ? response.json() : null)
    .catch(() => null);
  productCache.set(handle, promise);
  return promise;
}

function updateSelectedLegend(fieldset) {
  const legend = fieldset.querySelector('legend');
  const selected = fieldset.querySelector('input[type="radio"]:checked');
  if (!(legend instanceof HTMLElement) || !(selected instanceof HTMLInputElement)) return;
  let value = legend.querySelector('.lvtxiii-pattern-selected-value');
  if (!(value instanceof HTMLElement)) {
    value = document.createElement('span');
    value.className = 'lvtxiii-pattern-selected-value';
    legend.appendChild(value);
  }
  const nextText = selected.value ? `— ${selected.value}` : '';
  if (value.textContent !== nextText) value.textContent = nextText;
}

function decorateInput(input, variantById) {
  if (!(input instanceof HTMLInputElement)) return false;
  const optionName = (input.dataset.optionName || '').trim().toLowerCase();
  if (!['color', 'pattern', 'print'].includes(optionName)) return false;
  const variant = variantById.get(String(input.dataset.variantId || ''));
  const code = codeFromSku(variant?.sku);
  const position = code ? LVTXIII_PATTERN_POSITIONS[code] : null;
  if (!code || !position) return false;

  const label = input.closest('label.variant-option__button-label');
  if (!(label instanceof HTMLLabelElement)) return false;
  const existingImage = label.querySelector('.lvtxiii-pattern-swatch__image');
  if (
    label.dataset.lvtxiiiPatternDecorated === code &&
    label.classList.contains('lvtxiii-pattern-swatch') &&
    existingImage instanceof HTMLElement
  ) return true;

  existingImage?.remove();
  label.classList.add('lvtxiii-pattern-swatch');
  label.dataset.lvtxiiiPatternDecorated = code;
  label.title = input.value || code;
  input.dataset.lvtxiiiPatternCode = code;

  const image = document.createElement('span');
  image.className = 'lvtxiii-pattern-swatch__image';
  image.setAttribute('aria-hidden', 'true');
  image.style.backgroundPosition = `${-position[0] * LVTXIII_PDP_CELL}px ${-position[1] * LVTXIII_PDP_CELL}px`;
  input.insertAdjacentElement('afterend', image);
  return true;
}

async function decoratePicker(picker) {
  if (!(picker instanceof HTMLElement) || !picker.isConnected || picker.dataset.lvtxiiiPdpSwatchesBusy === 'true') return;
  picker.dataset.lvtxiiiPdpSwatchesBusy = 'true';
  try {
    const product = await loadProduct(picker);
    if (!product?.variants?.length || !picker.isConnected) return;
    ensurePdpPatternStyles();
    const variantById = new Map(product.variants.map((variant) => [String(variant.id), variant]));
    const fieldsets = new Set();
    for (const input of picker.querySelectorAll('input[type="radio"][data-variant-id]')) {
      if (decorateInput(input, variantById)) {
        const fieldset = input.closest('fieldset');
        if (fieldset instanceof HTMLFieldSetElement) fieldsets.add(fieldset);
      }
    }
    for (const fieldset of fieldsets) {
      fieldset.classList.add('lvtxiii-pattern-option');
      updateSelectedLegend(fieldset);
      if (fieldset.dataset.lvtxiiiLegendBound !== 'true') {
        fieldset.addEventListener('change', () => updateSelectedLegend(fieldset));
        fieldset.dataset.lvtxiiiLegendBound = 'true';
      }
    }
  } finally {
    delete picker.dataset.lvtxiiiPdpSwatchesBusy;
  }
}

function schedulePicker(picker) {
  if (!(picker instanceof HTMLElement) || !picker.matches('variant-picker[ref="mainVariantPicker"]')) return;
  pendingPickers.add(picker);
  if (decorateFrame !== null) return;
  decorateFrame = requestAnimationFrame(() => {
    decorateFrame = null;
    for (const item of Array.from(pendingPickers)) {
      pendingPickers.delete(item);
      if (item.isConnected) decoratePicker(item);
    }
  });
}

function applyPdpSwatches(root = document) {
  if (root instanceof Element) {
    if (root.matches('variant-picker[ref="mainVariantPicker"]')) schedulePicker(root);
    const ancestorPicker = root.closest('variant-picker[ref="mainVariantPicker"]');
    if (ancestorPicker instanceof HTMLElement) schedulePicker(ancestorPicker);
  }
  for (const picker of root.querySelectorAll?.('variant-picker[ref="mainVariantPicker"]') || []) schedulePicker(picker);
}

applyPdpSwatches();
document.addEventListener('DOMContentLoaded', () => applyPdpSwatches(), { once: true });
document.addEventListener('shopify:section:load', (event) => {
  if (event.target instanceof Element) applyPdpSwatches(event.target);
});

document.addEventListener('change', (event) => {
  const target = event.target;
  if (!(target instanceof Element)) return;
  const picker = target.closest('variant-picker[ref="mainVariantPicker"]');
  if (!(picker instanceof HTMLElement)) return;
  schedulePicker(picker);
  setTimeout(() => { if (picker.isConnected) schedulePicker(picker); }, 80);
  setTimeout(() => { if (picker.isConnected) schedulePicker(picker); }, 250);
}, true);

new MutationObserver((mutations) => {
  for (const mutation of mutations) {
    if (mutation.target instanceof Element) applyPdpSwatches(mutation.target);
    for (const node of mutation.addedNodes) {
      if (node instanceof Element) applyPdpSwatches(node);
    }
  }
}).observe(document.documentElement, { childList: true, subtree: true });
